// Macaron d'environnement (coin haut-gauche) : rappelle qu'on n'est pas en prod.
// REACT_APP_MOMO_ENV vaut "local" (compose de dev) ou la valeur MOMO_ENV du .env serveur, injectée
// au démarrage du conteneur front (docker/front/40-momo-env.sh). Absent ou "production" → rien.
const ENV = (process.env.REACT_APP_MOMO_ENV || '').toLowerCase();
const COLORS = { local: '#2563eb', preprod: '#ea580c', preproduction: '#ea580c' };

export default function EnvBadge() {
  if (!ENV || ENV === 'production' || ENV.startsWith('__')) return null;
  return (
    <div
      style={{
        position: 'fixed',
        left: 12,
        top: 12,
        zIndex: 99999,
        pointerEvents: 'none',
        padding: '3px 10px',
        borderRadius: 999,
        background: COLORS[ENV] || '#7c3aed',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
        boxShadow: '0 2px 8px rgba(0,0,0,.2)',
        opacity: 0.9,
      }}
    >
      {ENV}
    </div>
  );
}
